
import RedirectFetchObserver from 'lib/redirect_fetch_observer'

export default class RedirectToSelectOrganizationFetchObserver extends RedirectFetchObserver {
  get _redirectPath() {
    return Routes.organizationSelectPath()
  }
}
